module.exports = __webpack_public_path__ + "static/media/mw7.e0134336.webp";